import * as React from 'react';
import './style.scss';

interface LoadingBarProps {
    width: number;
    height: number;
    className?: string
}
const LoadingBar: React.FC<LoadingBarProps> = ({ width, height, className }) => {
    return (
        <div className={`loading-bar ${className}`} style={{ width: `${width}px`, height: `${height}px` }}></div>
    );
};

export default LoadingBar;
